// src/components/common/MantenimientoForm.js
//
// Estructura comun de las pantallas de mantenimiento: encabezado con volver,
// barra de guardar arriba y abajo, y el contenido del formulario en el medio.
// El boton guardar se deshabilita cuando la pagina es solo lectura.

import React from "react";
import { Box } from "@mui/material";
import PageHeader from "./PageHeader";
import SaveButtonBar from "./SaveButtonBar";

const MantenimientoForm = ({
    title,
    subtitle,
    backTo,
    onSave,
    disabled = false,
    saveText = "Guardar",
    showSave = true,
    extraActions,
    children,
}) => {
    const renderBarra = () => {
        if (!showSave && !extraActions) return null;
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1, py: 0.5 }}>
                {showSave && <SaveButtonBar text={saveText} onClick={onSave} disabled={disabled} />}
                {extraActions}
            </Box>
        );
    };

    return (
        <div>
            <PageHeader title={title} subtitle={subtitle} backTo={backTo} />

            {renderBarra()}

            {children}

            {renderBarra()}
        </div>
    );
};

export default MantenimientoForm;
